<template>
  <v-dialog v-model="dialog" max-width="350">
    <v-card elevation="0" outlined min-width="350">
      <v-card-title>Product Detail</v-card-title>
      <v-card-text>
        <div class="d-flex justify-center mb-2">
          <!-- <h3 class="red--text hot-blink" style="position: absolute; right: 2px">
          Popular
        </h3> -->
          <img
            class="image-preview"
            :src="getProductPictureUrlById(product.pictureId)"
          />
        </div>
        <v-form ref="form" v-model="formValid" lazy-validation>
          <div class="d-flex mb-2" style="gap: 5px">
            <v-text-field
              :rules="[
                (v) => !!v || 'Required',
                (v) => (!!v && v > 0) || 'Must be positive',
              ]"
              rounded
              outlined
              dense
              hide-details
              label="Stock Price"
              v-model.number="stock.stockPrice"
            ></v-text-field>
            <v-text-field
              :rules="[
                (v) => !!v || 'Required',
                (v) => (!!v && Number.isInteger(v)) || 'Must be a whole number',
                (v) => (!!v && v > 0) || 'Must be positive',
              ]"
              label="Quantity"
              rounded
              outlined
              dense
              hide-details
              v-model.number="stock.quantity"
            ></v-text-field>
          </div>

          <v-autocomplete
            class="mb-2"
            :rules="[(v) => !!v || 'Required']"
            rounded
            outlined
            dense
            hide-details
            :items="vendors"
            item-text="name"
            item-value="id"
            v-model="stock.vendorId"
            label="Vendor"
          >
          </v-autocomplete>
          <div class="mb-2">
            <date-picker v-model="stock.expDate" label="Exp Date"></date-picker>
          </div>
          <div>
            <date-picker
              :rules="[(v) => !!v || 'Required']"
              v-model="stock.datePurchased"
              label="Date Purchased"
            ></date-picker>
          </div>
        </v-form>
      </v-card-text>
      <v-card-actions class="d-flex justify-space-between">
        <div>
          <v-btn
            v-if="isUpdating"
            color="error"
            depressed
            icon
            @click="deleteStock"
            :loading="isDeleteLoading"
            ><i class="fa-solid fa-trash-can"></i
          ></v-btn>
        </div>
        <div>
          <v-btn
            v-if="!isUpdating"
            class="primary"
            depressed
            rounded
            @click="addStock"
            :loading="isLoading"
            :disabled="!formValid"
            ><i class="fa-solid fa-plus mr-2"></i>Add</v-btn
          >
          <v-btn
            v-else
            class="primary"
            depressed
            rounded
            @click="updateStock"
            :loading="isLoading"
            :disabled="!formValid"
          >
            <i class="fas fa-pencil-alt mr-2"></i>Update</v-btn
          >
        </div>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import DatePicker from "@/components/DatePicker.vue";
import generalMixin from "@/js/general-mixin";
import backendService from "@/services/backend-service";
export default {
  name: "InStockDialog",
  mixins: [generalMixin],
  components: {
    "date-picker": DatePicker,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    pProduct: {
      type: Object,
      default: () => {
        return {};
      },
    },
    pStock: {
      type: Object,
      default: () => {
        return {};
      },
    },
    isUpdating: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      formValid: false,
      isDeleteLoading: false,
      isLoading: false,
    };
  },
  computed: {
    stock: {
      get() {
        return this.pStock;
      },
      set(val) {
        this.$emit("set", val);
      },
    },
    dialog: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
    product: {
      get() {
        return this.pProduct;
      },
      set(val) {
        this.$emit("set-product", val);
      },
    },
    vendors() {
      return this.$store.getters["vendors"];
    },
  },
  created: function () {},

  methods: {
    addStock() {
      if (!this.$refs.form.validate()) return;
      this.isLoading = true;
      this.stock.productId = this.product.id;
      backendService.addStock(this.stock).then((response) => {
        this.product.usQuantity = response.data;
        this.product.quantity =
          this.product.usQuantity + this.product.vnQuantity;
        this.timer(1000).then(() => {
          this.stock = {};
          this.isLoading = false;
          this.dialog = false;
          this.$emit("add");
        });
      });
    },
    deleteStock() {
      this.isDeleteLoading = true;
      backendService.deleteStockById(this.stock.id).then((response) => {
        this.product.usQuantity = response.data;
        this.product.quantity =
          this.product.usQuantity + this.product.vnQuantity;
        this.timer(1000).then(() => {
          this.stock = {};
          this.isDeleteLoading = false;
          this.dialog = false;

          this.$emit("delete");
        });
      });
    },
    updateStock() {
      if (!this.$refs.form.validate()) return;
      this.isLoading = true;
      this.stock.updateQty = true;
      backendService.updateStock(this.stock).then((response) => {
        this.product.usQuantity = response.data;
        this.product.quantity =
          this.product.usQuantity + this.product.vnQuantity;
        this.timer(1000).then(() => {
          this.stock = {};
          this.isLoading = false;
          this.dialog = false;
          this.$emit("update");
        });
      });
    },
    forcePositiveNumber(field) {
      if (!isNaN(this.stock[field] && this.stock[field] < 0)) {
        this.stock[field] = 0;
      }
    },
    getProductPictureUrlById(imageId) {
      return backendService.getProductPictureUrlById(imageId);
    },
  },
  watch: {},
};
</script>
<style scoped>
.image-preview {
  object-fit: contain;
  image-rendering: smooth;
  width: 100px;
  height: 100px;
}
</style>
